/*
  ACCUEIL — comportements communs
  Pour Adrien d'Elzius · accueil v2 (trois portes)

  Chargé par chaque section de l'accueil, exécuté une seule fois.
  Rien ne joue de son sans un clic. Rien ne se télécharge chez Bandcamp
  tant que personne n'a demandé à écouter. Les vidéos muettes ne tournent
  que lorsqu'elles sont à l'écran, et jamais en mode économie de données
  ni quand le visiteur a demandé moins d'animations.
*/
(function () {
  if (window.__accInit) return;
  window.__accInit = true;

  var doc = document.documentElement;
  doc.classList.add('acc-js');

  var calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  var souris = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reseau = navigator.connection || {};
  var econome = reseau.saveData === true || /(^|-)2g$/.test(reseau.effectiveType || '');
  var animer = !calme.matches && !econome;
  if (!calme.matches) doc.classList.add('acc-smooth');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parImage(fn) {
    var t = 0;
    return function () {
      if (t) return;
      t = requestAnimationFrame(function () { t = 0; fn(); });
    };
  }
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function glisse() { return calme.matches ? 'auto' : 'smooth'; }

  /* ────────── le décalage : en-tête collant + barre de chapitres ────────── */
  function decalage() {
    var h = $('header-component');
    var c = $('[data-acc-chap]');
    var v = (h ? h.getBoundingClientRect().height : 0) + (c ? c.getBoundingClientRect().height : 0);
    doc.style.setProperty('--acc-offset', Math.round(v + 8) + 'px');
  }

  /* ────────── apparition au défilement ────────── */
  var vu = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); vu.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;

  function apparitions(root) {
    $$('[data-acc-reveal]', root).forEach(function (el) {
      if (vu) vu.observe(el); else el.classList.add('is-in');
    });
  }

  /* ────────── vidéos muettes : seulement à l'écran ────────── */
  function charger(v) {
    if (!v.getAttribute('src') && v.getAttribute('data-src')) {
      v.setAttribute('src', v.getAttribute('data-src'));
    }
  }
  function lire(v) {
    charger(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var ecran = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      var v = e.target;
      v.__accVisible = e.isIntersecting;
      if (v.closest('.is-live')) return;
      if (v.hasAttribute('data-acc-door-video') && !v.closest('.is-open')) return;
      if (e.isIntersecting && animer) lire(v); else v.pause();
    });
  }, { threshold: 0.25 }) : null;

  function videos(root) {
    $$('video[data-acc-autoplay], video[data-acc-door-video]', root).forEach(function (v) {
      if (v.__acc) return;
      v.__acc = 1;
      v.muted = true;
      if (ecran && animer) ecran.observe(v);
      else charger(v);
    });
  }

  /* ────────── les trois portes ────────── */
  function portes(root) {
    $$('[data-acc-doors]', root).forEach(function (wrap) {
      if (wrap.__acc) return;
      wrap.__acc = 1;
      var doors = $$('[data-acc-door]', wrap);
      var attente = 0;

      /* Le mot remonte exactement de la hauteur des boutons de sa porte :
         sur un écran étroit, deux boutons passent sur deux lignes, et le
         mot ne doit jamais se retrouver dessous. */
      function levage() {
        doors.forEach(function (d) {
          var m = d.querySelector('[data-acc-door-more]');
          if (m) d.style.setProperty('--lift', (m.offsetHeight + 16) + 'px');
        });
      }
      levage();
      window.addEventListener('resize', parImage(levage));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(levage);

      function ouvrir(i, focaliser) {
        doors.forEach(function (d, k) {
          var on = k === i;
          d.classList.toggle('is-open', on);
          var hit = d.querySelector('[data-acc-door-hit]');
          if (hit) hit.setAttribute('aria-expanded', on ? 'true' : 'false');
          var more = d.querySelector('[data-acc-door-more]');
          if (more) { if (on) more.removeAttribute('inert'); else more.setAttribute('inert', ''); }
          var v = d.querySelector('video[data-acc-door-video]');
          if (v) {
            if (on && animer && v.__accVisible !== false) lire(v);
            else v.pause();
          }
        });
        if (focaliser) {
          var cible = doors[i].querySelector('[data-acc-door-more] a, [data-acc-door-more] button');
          if (cible) setTimeout(function () { cible.focus({ preventScroll: true }); }, 60);
        }
      }

      doors.forEach(function (d, i) {
        var hit = d.querySelector('[data-acc-door-hit]');
        if (hit) {
          hit.addEventListener('click', function (e) {
            clearTimeout(attente);
            ouvrir(i, e.detail === 0);
          });
        }
        /* À la souris, la porte s'ouvre au survol, après une courte
           intention : traverser l'écran ne fait pas tout clignoter. */
        d.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse' || !souris.matches) return;
          clearTimeout(attente);
          attente = setTimeout(function () { ouvrir(i); }, 120);
        });
        d.addEventListener('pointerleave', function () { clearTimeout(attente); });
      });

      var depart = 0;
      doors.forEach(function (d, k) { if (d.classList.contains('is-open')) depart = k; });
      ouvrir(depart);
    });
  }

  /* ────────── la barre de chapitres ────────── */
  function chapitres(root) {
    $$('[data-acc-chap]', root).forEach(function (nav) {
      if (nav.__acc) return;
      nav.__acc = 1;
      var piste = nav.querySelector('[data-acc-chap-track]');
      var liens = $$('[data-acc-chap-link]', nav);
      var items = [];
      liens.forEach(function (a) {
        var id = (a.getAttribute('href') || '').split('#')[1];
        var el = id ? document.getElementById(id) : null;
        if (el) items.push({ a: a, el: el });
        else a.hidden = true;
      });
      if (!items.length) { nav.hidden = true; return; }

      var actif = -2;
      var maj = parImage(function () {
        var off = parseFloat(getComputedStyle(doc).getPropertyValue('--acc-offset')) || 120;
        var ligne = off + window.innerHeight * 0.2;
        var idx = -1;
        for (var i = 0; i < items.length; i++) {
          if (items[i].el.getBoundingClientRect().top <= ligne) idx = i;
        }
        if (idx !== actif) {
          items.forEach(function (it, k) {
            if (k === idx) it.a.setAttribute('aria-current', 'true');
            else { it.a.removeAttribute('aria-current'); it.a.style.setProperty('--p', 0); }
          });
          if (idx >= 0 && piste && piste.scrollWidth > piste.clientWidth) {
            var a = items[idx].a;
            piste.scrollTo({ left: a.offsetLeft - (piste.clientWidth - a.offsetWidth) / 2, behavior: glisse() });
          }
          actif = idx;
        }
        if (idx >= 0) {
          var r = items[idx].el.getBoundingClientRect();
          var p = Math.min(1, Math.max(0.04, (ligne - r.top) / Math.max(1, r.height)));
          items[idx].a.style.setProperty('--p', p.toFixed(3));
        }
      });
      /* Le thème fait défiler la page dans son propre conteneur (.page-wrapper),
         pas dans la fenêtre : on écoute le défilement partout, en capture. */
      document.addEventListener('scroll', maj, { passive: true, capture: true });
      window.addEventListener('resize', maj);
      maj();
    });
  }

  /* ────────── les carrousels ────────── */
  function carrousel(box) {
    if (box.__acc) return;
    box.__acc = 1;
    var piste = box.querySelector('[data-acc-track]');
    if (!piste) return;
    var prec = box.querySelector('[data-acc-prev]');
    var suiv = box.querySelector('[data-acc-next]');
    var compte = box.querySelector('[data-acc-count]');
    var barre = box.querySelector('[data-acc-progress]');
    var items = Array.prototype.slice.call(piste.children);

    function pas() {
      var a = items[0], b = items[1];
      if (!a) return piste.clientWidth;
      return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
    }
    function aller(d) { piste.scrollBy({ left: d * pas(), behavior: glisse() }); }
    if (prec) prec.addEventListener('click', function () { aller(-1); });
    if (suiv) suiv.addEventListener('click', function () { aller(1); });

    var maj = parImage(function () {
      var max = piste.scrollWidth - piste.clientWidth;
      var x = piste.scrollLeft;
      var i = Math.round(x / Math.max(1, pas()));
      if (x >= max - 4) i = items.length - 1;
      i = Math.max(0, Math.min(items.length - 1, i));
      if (compte) compte.textContent = deux(i + 1) + ' / ' + deux(items.length);
      if (barre) barre.style.setProperty('--p', max > 4 ? (0.08 + 0.92 * x / max).toFixed(3) : 1);
      if (prec) prec.disabled = x <= 4;
      if (suiv) suiv.disabled = x >= max - 4;
      box.classList.toggle('is-static', max <= 4);
    });
    piste.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();

    /* Glisser à la souris, comme au doigt. Un vrai glissement annule le
       clic qui suit : on ne tombe pas sur une œuvre par accident. */
    var tient = false, depart = 0, origine = 0, bouge = 0;
    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      tient = true; bouge = 0; depart = e.clientX; origine = piste.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!tient) return;
      var d = e.clientX - depart;
      if (!bouge && Math.abs(d) < 6) return;
      if (!bouge) piste.classList.add('is-drag');
      bouge = d;
      piste.scrollLeft = origine - d;
    });
    window.addEventListener('pointerup', function () {
      if (!tient) return;
      tient = false;
      if (!bouge) return;
      var x = piste.scrollLeft;
      piste.classList.remove('is-drag');
      piste.scrollLeft = x;
      var s = pas();
      var cible = Math.round((x + (bouge < 0 ? s * 0.25 : -s * 0.25)) / s) * s;
      piste.scrollTo({ left: cible, behavior: glisse() });
    });
    piste.addEventListener('click', function (e) {
      if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = 0; }
    }, true);
    piste.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ────────── le lecteur flottant (Bandcamp) ────────── */
  var lecteur = null;
  var enCours = null;

  function preparerLecteur() {
    if (lecteur) return lecteur;
    var p = $('[data-acc-player]');
    if (!p) return null;
    if (p.parentNode !== document.body) document.body.appendChild(p);
    var x = p.querySelector('[data-acc-player-close]');
    if (x) x.addEventListener('click', function () { fermerLecteur(true); });
    lecteur = p;
    return p;
  }

  function synchro() {
    $$('[data-acc-play]').forEach(function (b) {
      var on = !!enCours && b.getAttribute('data-embed') === enCours;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function ouvrirLecteur(btn) {
    var id = btn.getAttribute('data-embed');
    var url = btn.getAttribute('data-url');
    var p = preparerLecteur();
    if (!p || !id) {
      if (url) window.open(url, '_blank', 'noopener');
      return;
    }
    if (enCours === id && p.classList.contains('is-open')) { fermerLecteur(false); return; }
    couperCinema();
    enCours = id;
    var bg = p.getAttribute('data-bg') || '141716';
    var lk = p.getAttribute('data-link') || 'e39a78';
    var cadre = p.querySelector('[data-acc-player-frame]');
    cadre.textContent = '';
    var f = document.createElement('iframe');
    f.title = (p.getAttribute('data-frame-title') || 'Lecteur') + ' — ' + (btn.getAttribute('data-title') || '');
    f.src = 'https://bandcamp.com/EmbeddedPlayer/album=' + encodeURIComponent(id) +
      '/size=small/bgcol=' + bg + '/linkcol=' + lk + '/artwork=none/transparent=true/';
    f.setAttribute('allow', 'autoplay');
    f.setAttribute('seamless', 'seamless');
    cadre.appendChild(f);
    var t = p.querySelector('[data-acc-player-title]');
    var m = p.querySelector('[data-acc-player-meta]');
    var a = p.querySelector('[data-acc-player-link]');
    if (t) t.textContent = btn.getAttribute('data-title') || '';
    if (m) m.textContent = btn.getAttribute('data-meta') || '';
    if (a) { if (url) { a.href = url; a.hidden = false; } else { a.hidden = true; } }
    p.classList.add('is-open');
    document.body.classList.add('acc-has-player');
    synchro();
  }

  function fermerLecteur(rendreFocus) {
    if (!lecteur) return;
    var id = enCours;
    lecteur.classList.remove('is-open');
    document.body.classList.remove('acc-has-player');
    enCours = null;
    synchro();
    var cadre = lecteur.querySelector('[data-acc-player-frame]');
    setTimeout(function () { if (!enCours && cadre) cadre.textContent = ''; }, 650);
    if (rendreFocus && id) {
      var b = $('[data-acc-play][data-embed="' + id + '"]');
      if (b) b.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-acc-play]') : null;
    if (!b) return;
    e.preventDefault();
    ouvrirLecteur(b);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && enCours) fermerLecteur(true);
  });

  /* ────────── la salle de projection ────────── */
  var salles = [];
  function couperCinema() {
    salles.forEach(function (s) {
      if (s.classList.contains('is-live')) {
        var v = s.querySelector('video');
        if (v) v.pause();
      }
    });
  }
  function cinema(root) {
    $$('[data-acc-cine]', root).forEach(function (s) {
      if (s.__acc) return;
      s.__acc = 1;
      salles.push(s);
      var v = s.querySelector('video');
      var son = s.querySelector('[data-acc-cine-sound]');
      if (!v || !son) return;
      son.addEventListener('click', function () {
        fermerLecteur(false);
        charger(v);
        s.classList.add('is-live');
        v.muted = false;
        v.loop = false;
        v.controls = true;
        try { v.currentTime = 0; } catch (err) {}
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        v.focus({ preventScroll: true });
      });
    });
  }

  /* ────────── tout démarrer ────────── */
  function demarrer(root) {
    root = root || document;
    decalage();
    apparitions(root);
    videos(root);
    portes(root);
    chapitres(root);
    $$('[data-acc-slider]', root).forEach(carrousel);
    cinema(root);
  }

  demarrer(document);
  window.addEventListener('resize', parImage(decalage));
  window.addEventListener('load', decalage);
  if ('ResizeObserver' in window) {
    var h = $('header-component');
    if (h) new ResizeObserver(parImage(decalage)).observe(h);
  }
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
